import PartnersOptionList from './PartnersOptionList';
export default PartnersOptionList;
